import { IAppState } from '../../redux';
import { IServicePackage } from '../../redux/reducers';

export function selectPackages(state: IAppState): IServicePackage[] {
  const { packageIds, packages } = state.publishTerms;

  return packageIds.map(packageId => packages[packageId]);
}
